"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhoneNumber = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _libphonenumberJs = require("libphonenumber-js");
var _reactFlagsSelect = _interopRequireDefault(require("react-flags-select"));
var phoneStyles = _interopRequireWildcard(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var INVALID_PHONE_ERROR = 'Please enter a valid phone number.';
var validatePhoneNumber = function validatePhoneNumber(value, internationalPhoneSupportEnabled, message) {
  if (value) {
    var intlPhone = internationalPhoneSupportEnabled ? value : "+1".concat(value);
    var isPhoneValid = (0, _libphonenumberJs.isValidPhoneNumber)(intlPhone);
    return !isPhoneValid ? message || INVALID_PHONE_ERROR : undefined;
  }
  return undefined;
};
exports.validatePhoneNumber = validatePhoneNumber;
var PhoneInput = function PhoneInput(props) {
  var value = props.value,
    internationalPhoneSupportEnabled = props.internationalPhoneSupportEnabled,
    placeholder = props.placeholder,
    outdated = props.outdated,
    disabled = props.disabled,
    name = props.name,
    onChange = props.onChange,
    onBlur = props.onBlur,
    hasError = props.hasError,
    renderCountryCodeByDefault = props.renderCountryCodeByDefault;
  var phoneNoRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)('US'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedCountry = _useState2[0],
    setCountry = _useState2[1];
  (0, _react.useEffect)(function () {
    if (internationalPhoneSupportEnabled && renderCountryCodeByDefault && !value) {
      onChange('+1');
      setCountry('US');
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (value) {
      var country = 'US';
      var formatted = '';
      if (internationalPhoneSupportEnabled) {
        // get the phone code
        var phoneValue = value.includes('+') ? value : "+".concat(value);
        var asYouTypeNew = new _libphonenumberJs.AsYouType();
        formatted = asYouTypeNew.input(phoneValue);
        country = asYouTypeNew.getNumber() && asYouTypeNew.getNumber().country || selectedCountry;
      } else {
        var asYouType = new _libphonenumberJs.AsYouType(country);
        formatted = asYouType.input(value);
      }
      onChange(formatted);
      setCountry(country);
    }
  }, [value]);
  var formatPhoneNumber = function formatPhoneNumber(event) {
    var phone = event.target.value;
    var phoneVal = phone.replace(/\D/g, '');
    var formatted = '';
    if (phoneVal.length <= 15) {
      if (internationalPhoneSupportEnabled) {
        var asYouTypeNew = new _libphonenumberJs.AsYouType();
        formatted = asYouTypeNew.input(phone);
      } else {
        var asYouType = new _libphonenumberJs.AsYouType(selectedCountry);
        formatted = asYouType.input(phone);
      }
      onChange(formatted);
    }
  };
  var onKeyPress = function onKeyPress(e) {
    if (e && e.keyCode === 8) {
      var targetEle = e.target.value;
      if (targetEle.slice(-1) === ')') {
        e.target.setSelectionRange(targetEle.length - 1, targetEle.length - 1);
        e.target.focus();
      }
    }
  };
  var handleBlur = function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  };
  var handleFlagSelection = function handleFlagSelection(countryCode) {
    var phoneCode = "+".concat((0, _libphonenumberJs.getCountryCallingCode)(selectedCountry));
    setCountry(countryCode);
    var phoneNo = phoneNoRef.current && phoneNoRef.current.value;
    var phoneVal = phoneNo && phoneNo.replace(phoneCode, '');
    var asYouType = new _libphonenumberJs.AsYouType();
    var phone = "+".concat((0, _libphonenumberJs.getCountryCallingCode)(countryCode)).concat(phoneVal);
    var formatted = asYouType.input(phone);
    onChange(formatted);

    // close the country selector dropdown if doesn't auto close
    var countryDropdown = document.getElementById("".concat(name, "-btn"));
    if (countryDropdown && countryDropdown.nextElementSibling) {
      countryDropdown.click();
    }
  };
  var countrySelect = function countrySelect() {
    var options = {};
    var countryNames = new Intl.DisplayNames(['en'], {
      type: 'region'
    });
    (0, _libphonenumberJs.getCountries)().forEach(function (country) {
      options[country] = {
        primary: countryNames.of(country),
        secondary: '+'.concat((0, _libphonenumberJs.getCountryCallingCode)(country))
      };
    });
    var disabledClass = disabled ? 'disabled' : '';
    var highlightFlag = hasError || outdated ? 'flag-component' : '';
    return /*#__PURE__*/_react.default.createElement(_reactFlagsSelect.default, {
      rfsKey: name,
      selected: selectedCountry,
      showSelectedLabel: false,
      showSecondarySelectedLabel: false,
      searchable: true,
      customLabels: options,
      countries: (0, _libphonenumberJs.getCountries)(),
      onSelect: handleFlagSelection,
      className: "".concat(highlightFlag, " ").concat(disabledClass),
      disabled: disabled
    });
  };
  var phoneBorderClass = internationalPhoneSupportEnabled ? 'phone-border' : null;
  var phoneErrorClass = hasError || outdated ? 'phone-error' : null;
  var phoneBorder = internationalPhoneSupportEnabled && (hasError || outdated) ? 'input-phone-border' : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: phoneStyles['phone-component']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-field"
  }, internationalPhoneSupportEnabled && countrySelect(), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, props.input, props, {
    name: name,
    type: "text",
    ref: phoneNoRef,
    onChange: formatPhoneNumber,
    placeholder: placeholder,
    disabled: disabled,
    className: "phone-input ".concat(phoneBorder, " ").concat(phoneErrorClass, " ").concat(phoneBorderClass),
    onKeyDown: onKeyPress,
    onBlur: handleBlur
  }))));
};
PhoneInput.propTypes = {
  value: _propTypes.default.string,
  internationalPhoneSupportEnabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  outdated: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  input: _propTypes.default.shape({}).isRequired,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func.isRequired,
  hasError: _propTypes.default.bool,
  renderCountryCodeByDefault: _propTypes.default.bool
};
PhoneInput.defaultProps = {
  value: '',
  internationalPhoneSupportEnabled: false,
  placeholder: 'Enter phone number',
  onChange: function onChange() {
    return null;
  },
  outdated: false,
  disabled: false,
  name: 'phoneNumber',
  hasError: false,
  renderCountryCodeByDefault: false
};
var _default = PhoneInput;
exports.default = _default;